
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'Gallbladder_sarcoma',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Onco/Gallbladder_sarcoma.vue